import React, { useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/core/styles';
import { object, string, arrayOf, shape, func, bool } from 'prop-types';
import { withHandlers } from 'recompose';
import withTooltip from './withTooltip';

const styles = (theme) => ({
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: '100%',
    marginBottom: 0,
    marginTop: theme.spacing(1),
    textAlign: 'left',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
});

function SelectComponent(props) {
  const {
    id,
    label,
    value = '',
    options,
    classes,
    onChange = () => {},
    readOnly = false,
    required = false,
    error,
    loadData,
  } = props;

  useEffect(() => {
    if (options.length === 0) {
      loadData();
    }
  }, [options.length, loadData]);

  return (
    <FormControl
      required={required}
      key={`formControl-${id}`}
      className={classes.formControl}
      error={typeof error !== 'undefined'}
    >
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        aria-label="Gender"
        name="gender"
        className={classes.group}
        row
        value={value}
        onChange={onChange}
      >
        {options.map((option) => (
          <FormControlLabel
            key={`${id}-${option.value}`}
            disabled={readOnly}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      {typeof error !== 'undefined' && (
        <FormHelperText>{error || 'Required'}</FormHelperText>
      )}
    </FormControl>
  );
}

SelectComponent.propTypes = {
  classes: object.isRequired,
  id: string.isRequired,
  label: string.isRequired,
  value: string,
  options: arrayOf(
    shape({
      label: string.isRequired,
      value: string.isRequired,
    })
  ).isRequired,
  onChange: func.isRequired,
  loadData: func.isRequired,
  loading: bool,
  readOnly: bool,
  required: bool,
  tooltip: string,
  error: string,
};

SelectComponent.defaultProps = {
  value: '',
  onChange: () => {},
  loading: false,
  readOnly: false,
  required: false,
  tooltip: '',
  options: [],
  loadData: () => {},
};

const SelectWithTooltip = withTooltip(SelectComponent);
const enhance = withHandlers({
  onChange: (props) => (event) => {
    props.onChange(event.target.value);
  },
});

export default withStyles(styles)(enhance(SelectWithTooltip));



// WEBPACK FOOTER //
// ./src/view/forms/components/FormRadio.js